import * as R from 'ramda'
import { getQuizPage } from 'ducks/router.js'

// actions
export const FETCH_RESPONDENT = 'respondent/FETCH'
export const fetchRespondent = () => ({ type: FETCH_RESPONDENT })

export const RESET_RESPONDENT = 'respondent/RESET'
export const resetRespondent = () => ({ type: RESET_RESPONDENT })

export const UPDATE_RESPONDENT = 'respondent/UPDATE'
export const updateRespondent = payload => ({
  type: UPDATE_RESPONDENT,
  payload,
})

export const START_PERSONALITY = 'personality/START'
export const startPersonality = () => ({ type: START_PERSONALITY })

export const FINISH_PERSONALITY = 'personality/FINISH'
export const finishPersonality = () => ({ type: FINISH_PERSONALITY })

export const CHANGE_PERSONALITY_ANSWER = 'personality/CHANGE_ANSWER'
export const changePersonalityAnswer = ({ instrument, key, value }) => ({
  type: CHANGE_PERSONALITY_ANSWER,
  payload: { instrument, key, value },
})

export const START_GMA = 'gma/START'
export const startGMA = ({ reason }) => ({
  type: START_GMA,
  payload: { reason },
})

export const FINISH_GMA = 'gma/FINISH'
export const finishGMA = ({ reason }) => ({
  type: FINISH_GMA,
  payload: { reason },
})

export const SUBMIT_GMA = 'respondent/SUBMIT_GMA'
export const submitGMA = () => ({ type: SUBMIT_GMA })

export const SUBMIT_PERSONALITY = 'respondent/SUBMIT_PERSONALITY'
export const submitPersonality = () => ({ type: SUBMIT_PERSONALITY })

export const CHANGE_GMA_ANSWER = 'gma/CHANGE_ANSWER'
export const changeGMAAnswer = ({ key, value }) => ({
  type: CHANGE_GMA_ANSWER,
  payload: { key, value },
})

export const CHANGE_LANGUAGE = 'respondent/CHANGE_LANGUAGE'
export const changeLanguage = language => ({
  type: CHANGE_LANGUAGE,
  payload: { language },
})

// reducer
const initialState = {
  uuid: null,
  name: null,
  email: null,
  status: null,
  language: 'nb',
  personality: {
    status: 'fetching',
    answers: {},
  },
  gma: {
    status: 'fetching',
    answers: {},
  },
}

const toggleSubmit = status =>
  status === 'confirmsubmit' ? 'started' : 'confirmsubmit'

const countGMA = R.converge(R.assocPath(['stats', 'gma', 'totalAnswers']), [
  R.pipe(
    R.path(['gma', 'answers']),
    R.values,
    R.reject(R.isNil),
    R.length,
  ),
  R.identity,
])

const countPersonality = R.converge(
  R.assocPath(['stats', 'personality', 'totalAnswers']),
  [
    R.pipe(
      R.path(['personality', 'answers']),
      R.values,
      R.chain(R.values),
      R.reject(R.isNil),
      R.length,
    ),
    R.identity,
  ],
)

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return R.assoc('language', action.payload.language, state)
    case RESET_RESPONDENT:
      return R.mergeDeepLeft(initialState, state)
    case UPDATE_RESPONDENT:
      return R.mergeDeepLeft(action.payload, state)
    case CHANGE_PERSONALITY_ANSWER: {
      const { instrument, key, value } = action.payload
      return R.pipe(
        R.assocPath(['personality', 'answers', instrument, key], value),
        countPersonality,
      )(state)
    }
    case SUBMIT_PERSONALITY:
      return R.over(R.lensPath(['personality', 'status']), toggleSubmit, state)
    case CHANGE_GMA_ANSWER: {
      const { key, value } = action.payload
      return R.pipe(
        R.assocPath(['gma', 'answers', key], value),
        countGMA,
      )(state)
    }
    case SUBMIT_GMA:
      return R.over(R.lensPath(['gma', 'status']), toggleSubmit, state)
    default:
      return state
  }
}

// helper functions

// selectors
export const getRespondent = R.pipe(R.path(['respondent']))
export const getLanguage = R.pathOr('en', ['respondent', 'language'])

export const getGMA = R.converge(R.mergeRight, [
  R.path(['respondent', 'stats', 'gma']),
  R.path(['respondent', 'gma']),
])
export const getPersonality = R.converge(R.mergeRight, [
  R.path(['respondent', 'stats', 'personality']),
  R.path(['respondent', 'personality']),
])

export const getGMAQuestion = props => state => {
  const { page = 0, uuid } = props || getQuizPage(state)
  const { answers } = R.path(['respondent', 'gma'], state)
  const [question, value] = R.toPairs(answers)[page]
  return { question, value, current: page, uuid }
}

export const getPersonalityQuestion = props => state => {
  const { page = 0, uuid } = props || getQuizPage(state)
  const { instruments, questions, answers } = R.path(
    ['respondent', 'personality'],
    state,
  )
  if (!instruments) return { label: '', scale: {} }
  const { instrument, key } = R.prop(page, questions)
  const { scale, prompt, questions: qx } = R.prop(instrument, instruments)
  const { label } = R.find(R.propEq('key', key), qx)
  const value = R.path([instrument, key], answers)
  return {
    uuid,
    instrument,
    question: key,
    prompt,
    label,
    scale,
    value,
    current: page,
  }
}
